import { ZLICK_GET_SUBSCRIPTIONS } from './types'
export const locaSubscriptions = token => dispatch => {
  return dispatch({
    type: ZLICK_GET_SUBSCRIPTIONS,
    payload: {}
  })
}
